import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { create } from 'kts-scaffold-framework/utils/form';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import {
    Form,
    Button,
    Select
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const getFieldDecorator = this.props.form.getFieldDecorator;
        const departmentQuery = this.modulesState.departmentQuery ? this.modulesState.departmentQuery : [];
        return (
            <div className={css['setupDepartment']}>
                <Form>
                    <FormItem
                        label="所属部门"
                    >
                        {
                            getFieldDecorator('departmentId', {
                                rules: [
                                    {required: true, message: '你必须选择一个部门'}
                                ]
                            })
                            (
                                <Select>
                                    {departmentQuery.map(department => <Option key={department.departmentId}>{department.name}</Option>)}
                                </Select>
                            )
                        }
                    </FormItem>
                </Form>
                <div className={css['setupDepartment-hander']}>
                    <Button
                        type="primary"
                        onClick={this.setupDepartment}
                        className={`${css['dispatch-common-green']} ${css['dispatch-common-height']}`}
                    >设置
                    </Button>
                    <Button
                        onClick={this.hideAside}
                        className={`${css['dispatch-common-sliver']} ${css['dispatch-common-height']}`}
                    >关闭
                    </Button>
                </div>
            </div>
        );
    }

    private hideAside = () => {
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.hide, null);
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, null);
    }

    private setupDepartment = () => {
        this.props.form.validateFields((err, val) => {
            if(!err) {
                const options = Object.assign({}, {userId: this.modulesState.selectedUsers}, val);
                ModulesAction.setDepartment(options);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.SetupDepartment.tsx